<template>

   <div class=" px-6 py-8 rounded-lg bg-blue-imbt hover:bg-blue-hov hover:text-white">
      <p class="text-blue-textm hover:text-white text-base  "><span class="font-semibold text-2xl pb-4">Aluminium</span></p>
      <p class=" text-blue-textm text-base py-3">We provide 3 profiles, the European, South African and Middle East profile.</p>
     
     <ul class="list-disc marker:text-blue-500 text-base text-blue-textm hover:text-white text-base pl-5">
        <LI>Aluminium windows</LI>
        <li>Aluminium doors</li>
        <li>Aluminium enclosures</li>
        
        <li>Folding doors</li>
        <li>Shop fronts</li>
        <li>Aluminium partitions</li>
     </ul>
       </div>

</template>
<script>
 export default {
     name: 'Aluminium',
 }
</script>